/** @jsxImportSource @emotion/react */
import { CardHeader } from "../../../components/CardHeader";
import { FormRow } from "../../common/hook-form";
import * as Inputs from "../../common/hook-form/index";
import { useFormContext } from "react-hook-form";
import { ChallengePrerequisiteSelector } from "./ChallengePrerequisiteSelector";
import { SwitchInput } from "../../../components/forms/inputs/SwitchInput";
import { css } from "@emotion/react";
import { SelectProductInput } from "../../../components/forms/inputs/SelectProductInput";

const formRowStyle = css`
  margin-bottom: 16px;
`;

export const ChallengeRewardConfigSection = () => {
  const { register, formState, watch } = useFormContext();

  const hasPrerequisite = watch("hasPrerequisite");

  return (
    <div className="card">
      <CardHeader
        title="Reward configuration"
        subtitle="Configure the reward the user receives when completing the challenge and the last day they can claim their reward when hacing completed the challenge."
      />
      <div className="card-body">
        <FormRow className="mb-2">
          <SelectProductInput
            name="rewardProductId"
            label="Reward voucher"
            classification="voucher_type"
            // Price of voucher product cannot be non-zero
            filterProductsFunction={(products) =>
              products.filter((p) => p.price?.amount === 0)
            }
          />
        </FormRow>
        <FormRow>
          <Inputs.InputFormField
            errors={formState.errors}
            register={register}
            label="Last reward claim date"
            name="completedExpiresAt"
            type="datetime-local"
            helpText="The last day users who completed the challenge can claim their reward."
          />
        </FormRow>
        <FormRow css={formRowStyle}>
          <SwitchInput
            name="recurring"
            label="The challenge is recurring. If yes, the reward will be “recreated” for the user at the time of completion so the user can start over. Any progress (eg. money) that was above the goal will be transferred to the new challenge."
          />
        </FormRow>
        <FormRow css={formRowStyle}>
          <SwitchInput
            name="hasPrerequisite"
            label="Another challenge has to be completed to start this challenge. If yes, the challenge is not visible for the user until the prerequisite challenge is completed. If not it is visible if the challenge is enabled."
          />
        </FormRow>
        {hasPrerequisite && <ChallengePrerequisiteSelector />}
        <FormRow css={formRowStyle}>
          <SwitchInput
            name="enabled"
            label="Is enabled. Select if the challenge is enabled or not. Yes: The challenge will show and “earn” progress for users, respecting the settings above. No: The challenge will not be shown to users, and user “cannot earn” progress."
          />
        </FormRow>
        <FormRow css={formRowStyle}>
          <SwitchInput
            name="autoClaimReward"
            label="Should reward be automatically claimed when completing challenge. Select if the reward is automatically added to the wallet of the user when completing the challenge"
          />
        </FormRow>
      </div>
    </div>
  );
};
